import { Cart, CartItem } from 'modules/cart'
import { addDays } from 'shared/utils/date'

import { SaleOrder, SaleOrderProcessingStatus } from '../types'

export const isAvailableToCancelOrder = (date: string | Date) => {
  const orderDate = typeof date === 'string' ? new Date(date) : date

  const today = new Date()

  const addDaysToSunday = (7 - today.getDay()) % 7

  const lastCurrentWeekDay = addDays(today, addDaysToSunday)

  lastCurrentWeekDay.setHours(23, 50, 0, 0)

  return orderDate >= lastCurrentWeekDay
}

export const isCancelingBlockedByEditMode = (
  order: SaleOrder,
  cart: Cart | null
) => {
  //initial blocked until get curret cart
  if (!cart) return true

  if (cart.editMode && cart.saleOrderId === order.id) return true

  return false
}

// Order lifecycle notes:
// - New orders start with the `new` status.
// - After ~30 seconds, status changes to `awaiting_payment` (if unpaid)
//   or `paid` (if payment completed).
// - For `OnDelivery` or `LimitCredit` payment types, frontend maps status to
//   `accepted`.
// - Because of this we can assume that if the status is `new` the order is awaiting payment.
const TERMINAL_ORDER_STATUSES: SaleOrderProcessingStatus[] = [
  'paid',
  'accepted',
  'cancelled',
  'delivered',
  'in_delivery',
  'not_delivered'
]

export const isAwaitingPaymentSaleOrder = (
  order: SaleOrder | null | undefined
): boolean => {
  return (
    !!order?.onlinePaymentRequired &&
    !TERMINAL_ORDER_STATUSES.includes(order.status)
  )
}

// Drops promotional giveaways: the customer never picked them and the promotion
// engine grants them again on its own. Both flags come from GET /sale-orders/{id}.
export const filterReorderableItems = (items: CartItem[]): CartItem[] =>
  items.filter(
    item => !item.addedByPromotion && item.product?.productKind !== 'marketing'
  )
